import React from "react";
import AddIcon from "../../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ShipManagementCard from "../ShipManagementCard";
import { getShipManagementList, getPaintCoating, getEquipmentMachinery, getStructureAndHull, getStores, getShipManagementDetail } from "../../Actions/ShipManagementAPI";
import MDocSdocCardView from "./MDocSdocCardView";
import PoShipsCardView from "./PoShipsCardView";
import axios from "axios";
import API from "../../helpers/api";

class POShips extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                "pageNumber": 1,
                "pageSize": 25,
                "poNumber": "",
                "documentName": "",
                "status": ""
            },
            poListData: null,
            shipId: 0,
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.setState({ shipId: id });
        this.props.dispatch({ type: 'SubBannerTitle', data: "Md & SDoC Upload" });
        // this.props.dispatch(getShipManagementList(this.state.searchData));
        this.getShipList(this.state.searchData, id);
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.match.params.id;
        const currentId = this.props.match.params.id;

        if (prevId !== currentId) {
            this.setState({ shipId: currentId });

            // Call your function again with the new ID
            this.setState(prevState => ({
                searchData: { ...prevState.searchData, pageNumber: 1, pageSize: 25, poNumber: "", documentName: "", status: "" }
            }), () => {
                this.getShipList(this.state.searchData, currentId);
            });

            // this.getShipList(this.state.searchData, currentId);
        }
    }

    getShipList = (item, id) => {
        let url = `${API.MDSDPOlist}?shipId=${id}`;
        axios.post(url, item)
            .then((response) => {
                this.setState({ poListData: response.data });
            })
            .catch((error) => {
                console.log(error);
            })
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.pageNumber = Pgno;
        // dispatch(getShipManagementList(this.state.searchData));
        this.getShipList(this.state.searchData, this.state.shipId);
        window.scrollTo(0, 0);
        this.props.dispatch({ type: 'pagenumber', data: this.state.searchData });
    }

    eyeclick(item) {
        const { dispatch, history } = this.props;
        this.setState({ showSidePane: true })
        dispatch({ type: "ShowSidePan", data: true });
        //  dispatch({ type: "ShipDetails", data: item });
        history.push(`/Home/Management/Ship/${item.shipId}`);
        dispatch(getShipManagementDetail(item.shipId));
        dispatch(getPaintCoating(item.shipId));
        dispatch(getEquipmentMachinery(item.shipId));
        dispatch(getStructureAndHull(item.shipId));
        dispatch(getStores(item.shipId));
        window.scrollTo(0, 0);
    }

    NewitemNav = () => {
        this.props.history.push("/Home/Management/ShipAdd");
        this.props.dispatch({ type: "GetPaintCoatingList", data: null });
        this.props.dispatch({ type: "GetEquipmentMachineryList", data: null });
        this.props.dispatch({ type: "GetStructureHullList", data: null });
        this.props.dispatch({ type: "GetStoreList", data: null });
        this.props.dispatch({ type: "InventoryUploadSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadHKCSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadEUSSRSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadFullManualSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadFlagSOCSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadIAPPSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadampSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadldafdSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadecSuccess", data: "" });
    };

    ShowSidePanel = () => {
        this.setState({ showSidePane: false })
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    handleInputChange(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            searchData: { ...prevState.searchData, [name]: value }
        }));
        if (e.target.value === "") {
            // this.props.dispatch(getShipManagementList(this.state.searchData));
            this.getShipList(this.state.searchData, this.state.shipId);
        }
        this.setState({});
    }

    ClearInput() {
        // this.setState(prevState => ({
        //     searchData: { ...prevState.searchData, poNumber: "", documentName: "", status: "" }
        // }));
        // this.getShipList(this.state.searchData, this.state.shipId);
        this.setState(prevState => ({
            searchData: { ...prevState.searchData, poNumber: "", documentName: "", status: "", pageNumber: 1 }
        }), () => {
            // Now state is guaranteed to be updated
            this.getShipList(this.state.searchData, this.state.shipId);
        });
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    shipListdummy = {
        "items": [
            { "poNumber": "10001", "mDocName": "Invoice.pdf", "sDocName": "SignedInvoice.pdf", "status": "Exception" },
            { "poNumber": "10002", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10003", "mDocName": "PackingList.pdf", "sDocName": "VerifiedPackingList.pdf", "status": "Uploaded" },
            { "poNumber": "10004", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10005", "mDocName": "InspectionReport.pdf", "sDocName": "FinalReport.pdf", "status": "Uploaded" },
            { "poNumber": "10006", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10007", "mDocName": "Invoice.pdf", "sDocName": "SignedInvoice.pdf", "status": "Uploaded" },
            { "poNumber": "10008", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10009", "mDocName": "PackingList.pdf", "sDocName": "VerifiedPackingList.pdf", "status": "Uploaded" },
            { "poNumber": "10010", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10011", "mDocName": "BillOfLading.pdf", "sDocName": "FinalBOL.pdf", "status": "Uploaded" },
            { "poNumber": "10012", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10013", "mDocName": "ShippingLabel.pdf", "sDocName": "ScannedLabel.pdf", "status": "Uploaded" },
            { "poNumber": "10014", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10015", "mDocName": "Invoice.pdf", "sDocName": "SignedInvoice.pdf", "status": "Uploaded" },
            { "poNumber": "10016", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10017", "mDocName": "InspectionReport.pdf", "sDocName": "FinalReport.pdf", "status": "Uploaded" },
            { "poNumber": "10018", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10019", "mDocName": "Declaration.pdf", "sDocName": "SignedDeclaration.pdf", "status": "Uploaded" },
            { "poNumber": "10020", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10021", "mDocName": "Invoice.pdf", "sDocName": "SignedInvoice.pdf", "status": "Uploaded" },
            { "poNumber": "10022", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10023", "mDocName": "InspectionReport.pdf", "sDocName": "FinalReport.pdf", "status": "Uploaded" },
            { "poNumber": "10024", "mDocName": "", "sDocName": "", "status": "Pending" },
            { "poNumber": "10025", "mDocName": "Declaration.pdf", "sDocName": "SignedDeclaration.pdf", "status": "Uploaded" }
        ],
        "pageNumber": 1,
        "pageSize": 25,
        "totalCount": 76,
        "totalPages": 4,
        "hasPreviousPage": false,
        "hasNextPage": true
    }




    render() {
        const { ShipList } = this.props;
        return (
            <div className="full-height ">
                <div className="pt-3">
                    <div className="row resource-list-auth-date">
                        <div className="panel-box search-filter-box col-lg-12">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button>
                            <div className="pt-3">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="panel-box">
                                                    <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                                        <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                            <h5 className="card-title m-2" style={{ color: "092a51" }}>
                                                                Purchase Orders
                                                            </h5>
                                                            {/* <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="search-filter-box">
                                                        <div className="row">
                                                            <div className="col-lg-4">
                                                                <label className="form-label" >PO Number</label><br></br>
                                                                <input className="form-control" type="text" name="poNumber" value={this.state.searchData.poNumber} placeholder="PO Number" onChange={e => this.handleInputChange(e)}></input>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <label className="form-label" >Document Name</label><br></br>
                                                                <input className="form-control" type="text" name="documentName" value={this.state.searchData.documentName} placeholder="Document Name" onChange={e => this.handleInputChange(e)}></input>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <label className="form-label" >Status</label><br></br>
                                                                <select
                                                                    className="form-control"
                                                                    name="status"
                                                                    value={this.state.searchData.status}
                                                                    onChange={e => this.handleInputChange(e)}
                                                                >
                                                                    <option value="">Status</option>
                                                                    <option value="Uploaded">Uploaded</option>
                                                                    <option value="Pending">Pending</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-lg-12 d0flex justify-content-end">
                                                                <label></label><br></br>
                                                                <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                                    <button
                                                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                                        type="submit" onClick={() => this.SearchData(1)}>Search
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                                        type="button" onClick={() => this.ClearInput()}> {" "} Clear{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.poListData ?
                                            <PoShipsCardView
                                                arraylist={this.state.poListData.items}
                                                pageSize={this.state.poListData.pageSize}
                                                pageNumber={this.state.poListData.pageNumber}
                                                currentPage={this.state.poListData.currentPage}
                                                totalRecords={this.state.poListData.totalCount ? this.state.poListData.totalCount : 0}
                                                setUpdatedState={(value) => this.SearchData(value)}
                                                eyeclick={(item) => this.eyeclick(item)}
                                            />
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div>
                </div>
            </div>
        )
    }
    renderCard = () => [

    ]
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        ShipList: state.MasterScreenReducer.ShipList
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(POShips));